import { Guid } from 'guid-typescript';
export class EngagementRollUpModel {
    constructor() {
        this.id = Guid.create();
        this.name = '';
        this.completedActivities = 0;
        this.totalActivities = 0;
        this.doneHours = 0;
        this.totalHours = 0;
        this.currentStageName = '';
    }
}
export class EngagementRollUp extends EngagementRollUpModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
    get activityRatio() {
        return (this.completedActivities.toString() +
            '/' +
            this.totalActivities.toString());
    }
    get effortRatio() {
        return this.doneHours.toString() + '/' + this.totalHours.toString();
    }
}
